module.exports = "<span class=\"period-card-icon\" ng-show=\"$ctrl.isApproved()\">\n  <span class=\"icon-approved\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span></span>\n</span>\n<span class=\"period-card-icon\" ng-show=\"$ctrl.isRequested()\">\n  <span class=\"icon-requested\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span></span>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/vacations-absences.module/features/myVacations/periodList/periodCard/periodCardIcon/periodCardIcon.html
// module id = 1151
// module chunks = 0